"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalModeService = void 0;
class PortalModeService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Portalmodes({ currentUserIp, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/portalmodes/{currentUserIp}',
            path: {
                currentUserIp: currentUserIp,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1PortalmodesAuth({ currentUserIp, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/portalmodes/auth/{currentUserIp}',
            path: {
                currentUserIp: currentUserIp,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.PortalModeService = PortalModeService;
